import styled from 'styled-components';

export const SingleValueContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ImageSmall = styled.img`
  height: 24rem;
  width: 24rem;
  border-radius: 5rem;
`;
